__turbopack_context__.v({
  "Label": "SignupWizard-module-scss-module__t8rQBq__Label",
  "aboutField": "SignupWizard-module-scss-module__t8rQBq__aboutField",
  "aboutLabel": "SignupWizard-module-scss-module__t8rQBq__aboutLabel",
  "aboutLabelOptional": "SignupWizard-module-scss-module__t8rQBq__aboutLabelOptional",
  "aboutLabelText": "SignupWizard-module-scss-module__t8rQBq__aboutLabelText",
  "actionButton": "SignupWizard-module-scss-module__t8rQBq__actionButton",
  "badge": "SignupWizard-module-scss-module__t8rQBq__badge",
  "closeButton": "SignupWizard-module-scss-module__t8rQBq__closeButton",
  "col": "SignupWizard-module-scss-module__t8rQBq__col",
  "column": "SignupWizard-module-scss-module__t8rQBq__column",
  "content": "SignupWizard-module-scss-module__t8rQBq__content",
  "description": "SignupWizard-module-scss-module__t8rQBq__description",
  "field": "SignupWizard-module-scss-module__t8rQBq__field",
  "hint": "SignupWizard-module-scss-module__t8rQBq__hint",
  "illustration": "SignupWizard-module-scss-module__t8rQBq__illustration",
  "inputsLabel": "SignupWizard-module-scss-module__t8rQBq__inputsLabel",
  "inputsWrapper": "SignupWizard-module-scss-module__t8rQBq__inputsWrapper",
  "label": "SignupWizard-module-scss-module__t8rQBq__label",
  "link": "SignupWizard-module-scss-module__t8rQBq__link",
  "loader": "SignupWizard-module-scss-module__t8rQBq__loader",
  "logo": "SignupWizard-module-scss-module__t8rQBq__logo",
  "modal": "SignupWizard-module-scss-module__t8rQBq__modal",
  "modalContent": "SignupWizard-module-scss-module__t8rQBq__modalContent",
  "optImg": "SignupWizard-module-scss-module__t8rQBq__optImg",
  "optionContent": "SignupWizard-module-scss-module__t8rQBq__optionContent",
  "primary": "SignupWizard-module-scss-module__t8rQBq__primary",
  "prixClipFix": "SignupWizard-module-scss-module__t8rQBq__prixClipFix",
  "pulse": "SignupWizard-module-scss-module__t8rQBq__pulse",
  "root": "SignupWizard-module-scss-module__t8rQBq__root",
  "rotate": "SignupWizard-module-scss-module__t8rQBq__rotate",
  "row": "SignupWizard-module-scss-module__t8rQBq__row",
  "secondaryLabel": "SignupWizard-module-scss-module__t8rQBq__secondaryLabel",
  "teamOption": "SignupWizard-module-scss-module__t8rQBq__teamOption",
  "title": "SignupWizard-module-scss-module__t8rQBq__title",
});
